import { render, staticRenderFns } from "./customerLevel.vue?vue&type=template&id=2bb239b0&scoped=true&"
import script from "./customerLevel.vue?vue&type=script&lang=js&"
export * from "./customerLevel.vue?vue&type=script&lang=js&"
import style0 from "./customerLevel.vue?vue&type=style&index=0&id=2bb239b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb239b0",
  null
  
)

export default component.exports